<template>
    <ac-modal :title="'Notate Nacha'" :size-class="'modal-md'" ref="notateNachaModal">
        <div v-if="widgetReady">
            <textarea class="form-control form-long-field" rows="1"
                placeholder="Enter notes about NACHA file"
                v-model="notes" style="min-height: 40px;"></textarea>

            <div style="margin-top: 15px; text-align: right;">
                <ac-button class="btn btn-green btn-sm" :action="notateAch">SAVE</ac-button>
                <ac-button class="btn btn-red btn-sm" :action="closeAch">CANCEL</ac-button>
            </div>
        </div>
    </ac-modal>
</template>

<script>
    import AcModal from "../../../../../global/customHtmlElements/AcModal.vue";
    import {api} from "../../../../../global/framework/api.js";
    import {common} from "../../../../../global/common.js";

    export default {
        name: "NachaModal",
        components: {AcModal},
        props: { canRerunAch: { type: Boolean, default: true } },
        data() {
            return {
                widgetReady: false,
                batchId: 0,
                fileName: "",
                notes: ""
            };
        },
        methods: {
            async showModal(batchId, fileName) {
                this.widgetReady = false;
                this.batchId = batchId;
                this.fileName = fileName;

                var nachaNotes = await api.getDataById('PaymentReport', this.batchId, 'GetNachaNotes');
                if (nachaNotes.map(x => x.fileName).includes(fileName)) {
                    this.notes = nachaNotes.find(x => x.fileName === fileName).notes;
                } else {
                    this.notes = "";
                }

                this.$refs.notateNachaModal.open();
                this.widgetReady = true;
            },
            async notateAch() {
                let result = await api.postWithId('PaymentReport', this.batchId, 'NotateNacha',
                    {
                        batchId: this.batchId,
                        fileName: this.fileName,                        
                        notes: this.notes
                    });

                if (result) {
                    this.$emit('refresh');
                    this.closeAch();                    
                }
            },
            closeAch() {
                this.$refs.notateNachaModal.close();                
            },
        }
    }
</script>

<style scoped>
    strong {
        font-weight: bold !important;
    }
</style>